import { default as axios } from "axios";
import { tabSwitch } from "./tabSwitch.js";

export const contactForm = {
    formElem: null,
    hintBtn: null,
    shopNameInputWrapper: null,
    successMessage: null,
    errorMessage: null,
    hintBlock: null,
    contactFormTab: null,
    footercontactBtn: null,
    closeTabBtn: null,

    setElements() {
        this.formElem = document.querySelector('#plans-prices form#contact-form');
        this.hintBtn = document.querySelector('#plans-prices button.contact__hint-btn');
        this.shopNameInputWrapper = document.querySelector('#plans-prices form#contact-form .input-shop-name-wrapper');
        this.successMessage = document.querySelector('#plans-prices .contact__success-message');
        this.errorMessage = document.querySelector('#plans-prices .contact__error-message');
        this.hintBlock = document.querySelector('#plans-prices .contact__hint');
        this.contactFormTab = document.querySelector('.tabs__contact');
        this.footercontactBtn = document.querySelector('.contact-us__btn');
        this.closeTabBtn = document.querySelector('.contact__close-btn');
    },

    getShopQueryParam() {
        return new URLSearchParams(location.search).get('shop') ?? null;
    },

    getPlanQueryParam() {
        return new URLSearchParams(location.search).get('plan') ?? null;
    },

    showShopNameInput() {
        if (!this.shopNameInputWrapper) return;

        this.shopNameInputWrapper.classList.remove('hide');
    },

    hideShopNameInput() {
        if (!this.shopNameInputWrapper) return;

        this.shopNameInputWrapper.classList.add('hide');
    },

    BACKEND_BASE: 'https://app.thecustomproductbuilder.com/',
    BACKEND_STAGE_BASE: 'https://app-stage.thecustomproductbuilder.com/',

    async sendRequest(url, urlStage, data) {
        try {
            return await axios({
                method: "POST",
                timeout: 999999,
                crossDomain: true,
                url,
                data
            });
        } catch {
            return await axios({
                method: "POST",
                timeout: 999999,
                crossDomain: true,
                url: urlStage,
                data
            });
        };
    },

    sanitizeShopName(raw) {
        if (!raw || typeof raw !== 'string') return '';
        let s = raw.trim().toLowerCase();
        // remove protocol
        s = s.replace(/^https?:\/\//, '');
        // remove query string
        s = s.split('?')[0];
        // remove trailing slash
        s = s.replace(/\/$/, '');
        // take hostname if path present
        if (s.includes('/')) s = s.split('/')[0];
        // remove port
        s = s.replace(/:\d+$/, '');
        // remove .myshopify.com suffix
        s = s.replace(/\.myshopify\.com$/, '');
        return s;
    },

    sanitizeText(raw, maxLen = 20000) {
        if (!raw || typeof raw !== 'string') return '';
        let s = raw.replace(/<[^>]*>/g, '');
        s = s.replace(/\s+/g, ' ').trim();
        if (maxLen) s = s.slice(0, maxLen);
        return s;
    },

    sanitizeName(raw) {
        return this.sanitizeText(raw, 500);
    },

    sanitizeDetails(raw) {
        return this.sanitizeText(raw);
    },

    sanitizeEmail(raw) {
        if (!raw || typeof raw !== 'string') return '';
        return raw.trim().toLowerCase();
    },

    sanitizePhone(raw) {
        if (!raw || typeof raw !== 'string') return '';
        let s = raw.trim().replace(/[^0-9+]/g, '');
        if (s.length > 20) s = s.slice(0, 20);
        return s;
    },

    sumbit(e) {
        e.preventDefault();

        if (contactForm.formElem.classList.contains('pending')) return;

        contactForm.formElem.classList.add('pending');


        if (contactForm.errorMessage) {
            contactForm.errorMessage.classList.add('hide');
            const errTextEl = contactForm.errorMessage.querySelector('.error-message__text');
            if (errTextEl) errTextEl.textContent = '';
        }

        const formData = new FormData(e.target);

        const report = {};
        const status = 'client';
        const shop = contactForm.sanitizeShopName(formData.get('shop'));
        const url = new URL(`shop/${shop}/report-${status}`, contactForm.BACKEND_BASE).href;
        const urlStage = new URL(`shop/${shop}/report-${status}`, contactForm.BACKEND_STAGE_BASE).href;

        formData.delete('shop');
        formData.append('title', 'Enterprise')

        for (const [key, value] of formData.entries()) {
            if (key === 'details') {
                report['clientReport'] = [contactForm.sanitizeDetails(value)]
            } else if (/^clientName$|^name$/i.test(key)) {
                report[key] = contactForm.sanitizeName(value);
            }  else if (/^clientEmail$|^email$/i.test(key))  {
                report[key] = contactForm.sanitizeEmail(value);
            } else if (/^clientPhone$|^phone$/i.test(key))  {
                report[key] = contactForm.sanitizePhone(value);
            } else {
                report[key] = contactForm.sanitizeText(value);
            }
        };

        contactForm.sendRequest(url, urlStage, {
            shop,
            report,
            status   
        }).then(res => {
            console.log(res)
            contactForm.formElem.classList.add('hide');
            contactForm.formElem.classList.remove('pending');
            contactForm.hintBlock.classList.add('hide');
            contactForm.successMessage.classList.remove('hide');
        }).catch(error => {
            contactForm.formElem.classList.remove('pending');
            console.error(error.message);

            let errorTitle = 'There was a problem sending your request';
            let errorMessage = 'Please check the form and try again.';

            if (error?.response?.data?.message) {
                errorMessage = error.response.data.message;
            }

            if (contactForm.errorMessage) {
                contactForm.errorMessage.classList.remove('hide');
                const errTitle = contactForm.errorMessage.querySelector('.error-message__title');
                const errText = contactForm.errorMessage.querySelector('.error-message__text');
                if (errTitle) errTitle.textContent = errorTitle;
                if (errText) errText.textContent = errorMessage;
            }
        })
    },

    init() {
        this.setElements();
        if (!this.formElem || !this.hintBtn || !this.footercontactBtn || !this.closeTabBtn) return;

        this.hintBtn.addEventListener('click', () => {
            this.hintBtn.classList.add('hide');
            this.formElem.classList.remove('hide');
        });

        this.footercontactBtn.addEventListener('click', () => {
            this.hintBtn.classList.add('hide');
            this.formElem.classList.remove('hide');
            this.contactFormTab.classList.remove('hide');
            // tabSwitch.changeTab('enterprise');
        });

        this.closeTabBtn.addEventListener('click', () => {
            tabSwitch.changeTab('free');
            contactForm.successMessage.classList.add('hide');
        })

        if (this.getShopQueryParam()) {
            this.hideShopNameInput();
            const shopName = this.getShopQueryParam();
            this.shopNameInputWrapper.children[0].value = shopName;
        } else {
            this.showShopNameInput();
        }

        this.formElem.addEventListener('submit', this.sumbit);
    }
}
